export default {"appLinks":"py3K0"};